export const Types = {
  RESET_DATA: "measurement/RESET_DATA",
  GET_ALL_MEASUREMENT: "measurement/GET_ALL_MEASUREMENT",
  GET_ALL_MEASUREMENT_SUCCESS: "measurement/GET_ALL_MEASUREMENT_SUCCESS",
  GET_ALL_MEASUREMENT_ERROR: "measurement/GET_ALL_MEASUREMENT_ERROR",
  INACTIVATE_MEASUREMENT: "measurement/INACTIVATE_MEASUREMENT",
  ACTIVATE_MEASUREMENT: "measurement/ACTIVATE_MEASUREMENT",
  SHOW_OR_HIDE_DRAWER: "measurement/SHOW_HIDE_DRAWER",
};

export const Creators = {
  index: (groupId, farmId) => ({
    type: Types.GET_ALL_MEASUREMENT,
    payload: { groupId, farmId },
  }),
  indexSuccess: (data) => ({
    type: Types.GET_ALL_MEASUREMENT_SUCCESS,
    payload: { data },
  }),
  indexError: (error) => ({
    type: Types.GET_ALL_MEASUREMENT_ERROR,
    payload: { error },
  }),
  showOrHideDrawer: (id = null) => ({
    type: Types.SHOW_OR_HIDE_DRAWER,
    payload: { id },
  }),
  inactivateMeasurement: (groupId, farmId, id) => ({
    type: Types.INACTIVATE_MEASUREMENT,
    payload: { groupId, farmId, id },
  }),
  activateMeasurement: (groupId, farmId, id) => ({
    type: Types.ACTIVATE_MEASUREMENT,
    payload: { groupId, farmId, id },
  }),
};

const INITIAL_STATE = {
  isLoading: false,
  data: [],
  isDrawerVisible: false,
  measurementId: null,
  error: {},
};

export default function measurement(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.RESET_DATA:
      return INITIAL_STATE;
    case Types.GET_ALL_MEASUREMENT:
      return { ...state, isLoading: true };
    case Types.GET_ALL_MEASUREMENT_SUCCESS:
      return { ...state, isLoading: false, data: action.payload.data };
    case Types.GET_ALL_MEASUREMENT_ERROR:
      return {
        ...state,
        isLoading: false,
        data: null,
        error: action.payload.error,
      };
    case Types.SHOW_OR_HIDE_DRAWER:
      return {
        ...state,
        measurementId: action.payload.id,
        isDrawerVisible: !state.isDrawerVisible,
      };
    case Types.INACTIVATE_MEASUREMENT:
      return { ...state, isLoading: true };
    case Types.ACTIVATE_MEASUREMENT:
      return { ...state, isLoading: true };
    default:
      return state;
  }
}
